import PhoneIcon from "@mui/icons-material/PhoneInTalkOutlined";
import MailIcon from "@mui/icons-material/MailOutlineOutlined";
import LocationIcon from "@mui/icons-material/LocationOnOutlined";

export const SOCIAL_LINKS = [
    {
        icon: PhoneIcon,
        title: 'Телефон',
        text: 'Наши специалисты готовы принимать Ваши звонки в рабочее время офиса с 9:00 до 17:00 с понедельника по пятницу.',
        link: '+375 (29) 302-87-90',
    },
    {
        icon: MailIcon,
        title: 'Электронная почта',
        text: 'Заявки на электронную почту мы принимаем ежедневно в режиме 24/7. Будьте уверены, мы обязательно с вами свяжемся!',
        link: 'sales@veon-tech.ru',
    },
    {
        icon: LocationIcon,
        title: 'Местоположение офиса',
        text: 'Приглашаем Вас в наш офис. Также, есть возможность встреч с партнерами и заказчиками в удобном для Вас месте.',
        link: 'Минск, Сурганова, 57б, офис 187',
    },

];